export const defaultValues = {
  PROPERTY_VALUE: 250000,
  DEPOSIT: 1000,
  DURATION: "25",
  INTEREST: "3.5",
  DEFAULT_RESULT: true,
  INSTANT_RESULT: false,
  CURRENCY: "£",
  PRICE_PREFIX: true,
  DURATION_SUFFIX: true,
  YEAR_SUFFIX: true,
  YEAR_SELECT: true,
}
